export enum StorageKey {}

export class Storage {
  private static storage: Record<StorageKey, string> = {} as Record<StorageKey, string>;
  private static hasLocalStorage;

  static verifyLocalStorage() {
    if (this.hasLocalStorage === false) {
      return false;
    }
    try {
      localStorage.getItem('item');
      Storage.hasLocalStorage = true;
    } catch {
      Storage.hasLocalStorage = false;
    }
    return Storage.hasLocalStorage;
  }
  static set(key: StorageKey, value: any) {
    if (this.verifyLocalStorage()) {
      localStorage.setItem(key.toString(), JSON.stringify(value));
    }
    this.storage[key] = JSON.stringify(value);
  }

  static get(key: StorageKey) {
    const value = this.verifyLocalStorage()
      ? localStorage.getItem(key.toString())
      : this.storage[key];
    return value ? JSON.parse(value) : null;
  }
}
